import React from "react";
import { Link } from "react-router-dom";
import "./Resources.scss";
import NavBar from "../../shared/components/NavBar/NavBar";
import Footer from "../../shared/components/Footer/Footer";
import PageHeader from "../../shared/components/PageHeader/PageHeader";
import { resources } from "../../shared/resources";

const Resources: React.FC = () => (
  <div className="ss-resources fade-in">
    <NavBar active="resources" />
    <PageHeader
      crumb="Resources"
      eyebrow="Resources"
      title="Learning Resources"
      lead="Free course notes, workshop material and labs to learn from at your own pace."
    />

    <section className="ss-section">
      <div className="ss-container">
        <div className="ss-grid ss-grid--3">
          {resources.map((resource) => (
            <a
              key={resource.href}
              className="ss-resource"
              href={resource.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="ss-resource__top">
                <span className="ss-resource__icon">
                  <i className="bi bi-journal-code" aria-hidden="true"></i>
                </span>
                {resource.specialization && (
                  <span className="ss-resource__spec">{resource.specialization}</span>
                )}
              </div>
              <h2>{resource.title}</h2>
              <p className="ss-resource__source">{resource.source}</p>
              <p>{resource.description}</p>
              <ul className="ss-resource__topics">
                {resource.topics.map((topic) => (
                  <li key={topic}>{topic}</li>
                ))}
              </ul>
              <span className="ss-resource__cta">
                Open resource
                <i className="bi bi-box-arrow-up-right" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>

        <div className="ss-resources__more">
          <p>Want guided, hands-on learning on these topics?</p>
          <Link to="/program-catalog" className="ss-btn ss-btn--accent">
            Explore Programs <i className="bi bi-arrow-right" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </section>

    <Footer isFinancialInquiries={true} />
  </div>
);

export default Resources;
